<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--     <a-form-model-item label="用户id，外键{user.id}" prop="userId" >-->
<!--        <a-input v-model="form.userId" placeholder="请输入用户id，外键{user.id}" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="反馈类型" prop="type" >
        <dict-tag :options="dict.type.feedback_type" :value="form.type"/>
      </a-form-model-item>
      <a-form-model-item label="处理状态" prop="processStatus" >
        <a-tag :color="getProcessStatusColor(form.processStatus)">
          {{ getProcessStatusLabel(form.processStatus) }}
        </a-tag>
      </a-form-model-item>
      <a-form-model-item label="反馈内容" prop="content" >
        <a-input type="textarea" readOnly v-model="form.content" />
      </a-form-model-item>
<!--      <a-form-model-item label="处理状态" prop="processStatus" >-->
<!--        <a-radio-group v-model="form.processStatus">-->
<!--          <a-radio :value="1">待处理</a-radio>-->
<!--          <a-radio :value="2">已处理</a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->


<!--      <a-form-model-item label="联系方式" prop="contact" >-->
<!--        <a-input readOnly v-model="form.contact" placeholder="请输入联系方式" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="反馈图片" prop="imgUrls" v-if="form.imgUrls">
        <img v-viewer  v-for="(pic) in form.imgUrls.split(',')" style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
              :src="processImageUrl(pic)" preview="反馈图片"/>
      </a-form-model-item>
      <a-form-model-item label="视频" prop="imgUrls" v-if="form.videoUrls">
        <video   v-for="(item) in form.videoUrls.split(',')" style="width: 180px;height: 120px"
                 class="avatar video-avatar"
                 controls="controls"
                 :src="item" />

      </a-form-model-item>

      <a-form-model-item label="处理结果" prop="processResult">
        <a-input type="textarea" :readOnly="form.processStatus !== 1" v-model="form.processResult" placeholder="请输入处理结果" :rows="4" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button v-if="form.processStatus ==1" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getFeedback, addFeedback, updateFeedback } from '@/api/app/feedback'
import Editor from '@/components/Editor'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'CreateForm',
  dicts: ['feedback_type'],
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        content: null,

        processStatus: 0,

        processResult: null,

        imgUrls: null,

        contact: null,

        remark: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id，外键{user.id}不能为空', trigger: 'blur' }
        ],
        processResult: [
          { required: true, message: '处理结果不能为空', trigger: 'blur'}
        ],
        type: [
          { required: true, message: '反馈类型：1-意见建议、2-故障报告、3-投诉不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    processImageUrl,
    getProcessStatusLabel(status) {
      const statusMap = {
        1: '待处理',
        2: '已处理'
      }
      return statusMap[status] || '未知'
    },
    getProcessStatusColor(status) {
      const colorMap = {
        1: 'orange',
        2: 'green',
        3: 'red'
      }
      return colorMap[status] || 'default'
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        processStatus: 0,
        processResult: null,
        imgUrls: null,
        contact: null,
        remark: null,
        createTime: null,
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getFeedback({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        if(this.form.processStatus ==1){
          this.formTitle = '回复'
        }else{
          this.formTitle = '详情'
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            this.form.processStatus = 2
            updateFeedback(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFeedback(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
